module.exports = __webpack_public_path__ + "static/media/wechat.5fcae7e9.png";